// libs
import { connect } from 'react-redux';
import get from 'lodash/get';
// errors
import Errors from 'dux/errors/errors';
// Components
import CatalogButton from './catalog-button';
// actionCreators
import { fetchCatalogUrl } from '../api';
import { dismissErrorsByType } from 'dux/errors';

export const mapStateToProps = state => ( {
    disabled: get( state, 'user.isLaunchAs', false ),
    busy: get( state, 'data.fetching.catalogUrl', false ),
    fetchCatalogUrlErrors: Errors.getByType( state, Errors.ERROR_SHOP_FETCH_CATALOG_URL )
} );

export const mapDispatchToProps = {
    dismissErrorsByType,
    fetchCatalogUrl
};

export default connect( mapStateToProps, mapDispatchToProps )( CatalogButton );
